import { jsx } from 'react/jsx-runtime';
import { createElement } from 'react';
import { FloatingBox } from '../../display/FloatingBox/FloatingBox.es.js';

const list = "_list_i0z7c_1";
const menuItem = "_menu-item_i0z7c_10";
const menuItemIcon = "_menu-item-icon_i0z7c_29";
const menuItemText = "_menu-item-text_i0z7c_37";
const styles = {
	list: list,
	menuItem: menuItem,
	menuItemIcon: menuItemIcon,
	menuItemText: menuItemText
};

const MENU_ITEM_HEIGHT = 40;
const FloatingMenu = (_props) => {
  const props = Object.assign({ align: "stretch", visibleItems: 4 }, _props);
  const { align, "aria-label": ariaLabel, getItemProps, getKeyForItem, getLabelForItem, getMenuProps, highlightedIndex, items, maxWidth, minWidth, visibleItems } = props;
  const maxHeight = ((visibleItems || 0) + 0.5) * MENU_ITEM_HEIGHT + 10;
  const maxHeightInPixels = `${maxHeight}px`;
  return jsx(FloatingBox, { align, maxWidth, minWidth, children: jsx("ul", Object.assign({}, getMenuProps({ "aria-label": ariaLabel }), { className: styles.list, "data-zds": true, style: {
    "--_zds-floating-menu-max-height": maxHeightInPixels
  }, children: items.map((item, index) => createElement(
    "li",
    Object.assign({}, getItemProps({ item, disabled: item.disabled }), { className: styles.menuItem, "data-disabled": item.disabled ? true : void 0, "data-highlighted": highlightedIndex === index ? true : void 0, key: getKeyForItem ? getKeyForItem(item) : index, "data-zds": true }),
    props.renderIcon && jsx("span", { className: styles.menuItemIcon, "data-zds": true, children: props.renderIcon(item, props.getLabelForItem) }),
    jsx("span", { className: styles.menuItemText, "data-zds": true, children: getLabelForItem(item) })
  )) })) });
};

export { FloatingMenu };
//# sourceMappingURL=FloatingMenu.es.js.map
